import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Shipskis',
  description: `
      The best way to ship your skis and snowboards.
      We offer white-glove, door-to-door shipping services worldwide.
      Get a FREE quote today!`,
  icons: {
    icon: [{ url: '/shipskis.favicon.png', type: 'image/png' }, { url: '/shipskis.favicon.ico' }],
  },
  alternates: {
    canonical: 'https://www.shipskis.com',
  },
}

export default metadata
